import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import Faq from '../views/Faq.vue'
import RecoveryPass from '../views/RecoveryPass.vue'
import Registr from '../views/Registr.vue'

import Home from '../views/Home.vue'
import Main from '../views/Main.vue'

import AccountInfo from '../views/AccountInfo.vue'

import UserAddress from '../components/userAddress/UserAddress.vue'
import AddNewAddress from '../views/AddNewAddress.vue'
import FeedBack from '../components/FeedBack.vue'
import UserProfile from '../components/userProfile/UserProfile.vue'
import PageNotFound from '../components/PageNotFound.vue'

import config from '../config'



import testRegistration from '../views/testRegistration.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: `${config.ROUTE_PREFIX}`,
    name: 'Main',
    component: Main,
    meta: { auth: true },    
  },
  {
    path: `${config.ROUTE_PREFIX}/account/:id`,
    name: 'AccountInfo',
    props: true,
    component: AccountInfo,
    meta: { auth: true },    
  }, 
  {
    path: `${config.ROUTE_PREFIX}/bills`,
    component: Home,
    meta: { auth: true },
    children:[
      {
        path: `${config.ROUTE_PREFIX}/bill`,
        component: UserAddress,
        name: 'UserAddress',
        meta: { auth: true }
      },

      {
        path: `${config.ROUTE_PREFIX}/profile/`,
        name: 'UserProfile',
        component: UserProfile,
        meta: { auth: true }
      },
      {
        path: `${config.ROUTE_PREFIX}/feedback/:id`,
        name: 'feedBack',
        props: true,
        component: FeedBack,
        meta: { auth: true }
      },
    ]
  },
  {
    path: `${config.ROUTE_PREFIX}/account/add`,
    name: 'NewAddress',
    component: AddNewAddress,
    meta: { auth: true }
  },

  {
    path: `${config.ROUTE_PREFIX}/login`,
    name: 'Login',
    component: Login
  },
  {
    path: `${config.ROUTE_PREFIX}/faq`,
    name: 'Faq',
    component: Faq
  },
  {
    path: `${config.ROUTE_PREFIX}/old-registration`,
    name: 'Registr',
    component: Registr
  },
  {
    path: `${config.ROUTE_PREFIX}/recovery`,
    name: 'RecoveryPass',
    component: RecoveryPass
  },
  {
    path: `${config.ROUTE_PREFIX}/registration`,
    name: 'testRegistration',
    component: testRegistration,
  },
  {
    path: `*`,
    name: 'PageNotFound',
    component: PageNotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( (to, from, next)=>{
  const requireAuth = to.matched.some(record => record.meta.auth)
  const currentUser = localStorage.getItem('weltumKey')
  
  if(requireAuth && !currentUser == true){
    next(`${config.ROUTE_PREFIX}/login`)
  } else {
    next()
  }
} )


export default router
